import { NotifyModal } from "./NotifyModal";

export default NotifyModal;